export default __webpack_public_path__ + "media/images/react_icons/calendar_landlord-6f49903d53a76d5dab564064545edd16.svg";